module.exports = __webpack_public_path__ + "img/Payment-Paypal.ac794743.jpg";